<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  <a mat-tab-link routerLink="overview" routerLinkActive #rla1="routerLinkActive" [active]="rla1.isActive"> Overview </a>
  <a mat-tab-link routerLink="clients" routerLinkActive #rla2="routerLinkActive" [active]="rla2.isActive"> Clients </a>
  <a mat-tab-link routerLink="customers" routerLinkActive #rla3="routerLinkActive" [active]="rla3.isActive"> Customers </a>
</nav>
<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
